import ApiKeyManagementFromNonHumansToggle from "components/ApiKeys/ApiKeyManagementFromNonHumansToggle";
import NonRootApiKeysToggle from "components/ApiKeys/NonRootApiKeysToggle";
import PersonalApiKeysToggle from "components/ApiKeys/PersonalApiKeysToggle";
import PageWrapper from "components/PageWrapper";
import Box from "ds/components/Box";
import Card from "ds/components/Card";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import useTypedFlags from "hooks/useTypedFlags";
import useCanManageApiKeys from "shared/ApiKey/access/useCanManageApiKeys";
import { AccountContext } from "views/AccountWrapper";

import { SettingsContext } from "../../Context";
import { UserManagementActivationStatus } from "../../types";
import ApiKeysPageLayout from "../PageLayout";
import {
  API_KEYS_SETTINGS_NO_ACCESS_TOOLTIP,
  PERSONAL_API_KEYS_LOGIN_POLICY_TOOLTIP,
} from "./constants";

const ApiKeysSettings = () => {
  const { enableApiKeyCreationForNonRootAdminsFrontend } = useTypedFlags();
  const { accountName } = useTypedContext(AccountContext);
  const { activationStatus } = useTypedContext(SettingsContext);
  const canManageApiKeys = useCanManageApiKeys();

  useTitle(`Organization Settings · API keys · Settings · ${accountName}`);

  const settingsTooltip = canManageApiKeys ? undefined : API_KEYS_SETTINGS_NO_ACCESS_TOOLTIP;
  const isManagedUsersActive = activationStatus === UserManagementActivationStatus.ACTIVE;

  return (
    <ApiKeysPageLayout>
      <PageWrapper>
        <Box direction="column" limitWidth="medium" gap="x-large" fullWidth>
          <Card contentGap="large">
            <PersonalApiKeysToggle
              disabled={!isManagedUsersActive || !canManageApiKeys}
              tooltip={
                isManagedUsersActive ? settingsTooltip : PERSONAL_API_KEYS_LOGIN_POLICY_TOOLTIP
              }
            />
            {enableApiKeyCreationForNonRootAdminsFrontend && (
              <NonRootApiKeysToggle disabled={!canManageApiKeys} tooltip={settingsTooltip} plain />
            )}
            <ApiKeyManagementFromNonHumansToggle
              disabled={!canManageApiKeys}
              tooltip={settingsTooltip}
              plain
            />
          </Card>
        </Box>
      </PageWrapper>
    </ApiKeysPageLayout>
  );
};

export default ApiKeysSettings;
